// components/RenderVector.tsx
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { DashedTag } from '@/components/chariot-ui';

import { Tooltip } from '@/components/Tooltip';
import { parseCVSSVector } from '@/sections/threats/utils';

interface RenderVectorProps {
  vector: string;
  version: string;
  metricGroup: string;
}

/**
 * Render CVSS vector metrics as labeled tags
 */
export function RenderVector({
  vector,
  version,
  metricGroup,
}: RenderVectorProps) {
  const metrics = parseCVSSVector(vector ?? '', version, metricGroup);

  return (
    <div className="flex flex-wrap gap-2">
      {metrics.map((metric, index) => (
        <div className="flex items-center gap-1 pr-2" key={index}>
          <h1 className="font-bold">{metric.key}</h1>
          <Tooltip title={metric.name} placement="top">
            <InformationCircleIcon className="[&_path]:text-chariot-stroke size-4" />
          </Tooltip>
          <DashedTag
            size="xs"
            label={metric.label}
            className="border-chariot-text-secondary bg-chariot-text-primary/10 ml-1 py-0"
          />
        </div>
      ))}
    </div>
  );
}
